import { render } from "./SkeletonWrapper.vue?vue&type=template&id=7f53dfa3"
import script from "./SkeletonWrapper.vue?vue&type=script&lang=js"
export * from "./SkeletonWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__